
















import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';
import { apiProvider } from '../api';

type DataType = {
	X_CHECKIN_NR_ZKT: number;
	SPZ: string;
	KAROSERIE_NR: string,
	VSTUP_DAT: string,
	CHECKIN_ID: number,
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'CHECKIN_ID' },
		isClearable: { type: Boolean, default: true },
		isEditable: { type: Boolean, default: false },
		filter: { type: Object, default: () => {} },
		text: { type: [String, Date], default: null },
		value: { type: Number, default: undefined },
	},
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'CHECKIN_ID',
			apiProvider,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
			},
		};
	},
	computed: {
		valueCmp: {
			get() {
				return this.value ? this.value.toString() : null;
			},
			set(val) {
				this.$emit('update:value', val ? Number(val) : null);
			},
		},
	},
	methods: {
		fetchCheckIn(this: { apiProvider: any }, filter: object) {
			return apiProvider.checkInChange(filter);
		},
		dbToBaseMapper(data: DataType) {
			return {
				value: data.X_CHECKIN_NR_ZKT,
				spz: data.SPZ,
				karoserieNr: data.KAROSERIE_NR,
				vstupDat: data.VSTUP_DAT,
				id: data.CHECKIN_ID,
			};
		},
		querySearchAsync(queryString: string, cb: any) {
			this.apiQuery({
				CheckinNr: this.filter.CheckinNr,
				VozidloId: this.filter.VozidloId,
				ZakaznikId: this.filter.ZakaznikId,
				ZakazkaId: this.filter.ZakazkaId,
			}, cb);
		},
		apiQuery(filterSearch: any, cb: any) {
			apiProvider.checkInChange(filterSearch).then((res: any) => {
				cb([]);
				if (res.data.CheckinId && res.data.CheckinVstupDat) {
					this.$emit('updateCheckIn', res.data);
				}
			});
		},
	},
});
